import withRouteParams from 'hoc/withRouteParams';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { checkAndGetCancellationReasons } from 'ducks/cancellationReasons';
import {
  getPersonalInfo,
  getTransactions,
  getPendingPaymentAmount,
} from 'ducks/customerDetails';
import { cancelAccount } from 'ducks/accounts';
import {
  getEstimatedFinalBillDate,
  getOutstandingDsFee,
  getBalanceToSettleWithoutCancelFee,
} from 'ducks/accountMeta';
import { getFacilityByAdfitNo } from 'ducks/facilities';
import { selectEntitiesByAdfitNo } from 'selectors/common';
import { makeSelectFacilityByAdfitNo } from 'selectors/facilities';
import withScrollableTopTabs from 'hoc/withScrollableTopTabs';
import customerPageTopTabs from 'constants/customerPageTopTabs';
import Cancellation from './Cancellation';

const makeMapStateToProps = () => {
  const selectFacilityByAdfitNo = makeSelectFacilityByAdfitNo();

  return (state, ownProps) => {
    const { adfitNo } = ownProps.routeParams;
    return {
      cancellationReasons: selectEntitiesByAdfitNo(
        state.cancellationReasons,
        adfitNo
      ),
      account: state.customerDetails,
      localisation: state.localisation,
      transactions: state.customerDetails.lastest3Transactions,
      pendingPaymentAmount: state.customerDetails.pendingPaymentAmount,
      estimatedFinalBillDate: selectEntitiesByAdfitNo(
        state.accountMeta.estimatedFinalBillDate,
        adfitNo
      ),
      outstandingDsFee: selectEntitiesByAdfitNo(
        state.accountMeta.outstandingDsFee,
        adfitNo
      ),
      balanceToSettleWithoutCancelFee: selectEntitiesByAdfitNo(
        state.accountMeta.balanceToSettleWithoutCancelFee,
        adfitNo
      ),
      facility: selectFacilityByAdfitNo(state, adfitNo),
      permissions: state.auth.permissions,
    };
  };
};

const mapDispatchToProps = {
  getCancellationReasons: checkAndGetCancellationReasons,
  getAccountInfo: getPersonalInfo,
  getTransactions,
  getPendingPaymentAmount,
  cancelAccount,
  getEstimatedFinalBillDate,
  getOutstandingDsFee,
  getBalanceToSettleWithoutCancelFee,
  getFacilityByAdfitNo,
};

export default compose(
  withScrollableTopTabs(customerPageTopTabs, 0, ['adfitNo']),
  withRouteParams,
  connect(makeMapStateToProps, mapDispatchToProps)
)(Cancellation);
